import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/not-found.tsx");
